import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { hasChatbotConsent, revokeChatbotConsent } from './consent';

/**
 * Widerrufs-Link im Footer (Art. 7 Abs. 3 DSGVO: Widerruf so einfach wie
 * die Erteilung). Erscheint nur, wenn eine Chat-Einwilligung gespeichert
 * ist; Klick entfernt sie und lädt die Seite neu (entfernt das Script).
 */
export function ChatbotConsentFooterLink() {
  const { t } = useTranslation();
  // Einmal beim Mount lesen reicht — nach Grant/Revoke wird eh neu gerendert
  // bzw. neu geladen.
  const [visible] = useState(() => hasChatbotConsent());

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={revokeChatbotConsent}
      className="text-left"
      style={{ font: 'inherit', color: 'inherit' }}
    >
      {t('chatbot.footerRevoke')}
    </button>
  );
}
